import React, { useState } from 'react';

const truncateHTML = (html, limit) => {
    let truncated = '';
    let count = 0;
    let inTag = false;

    for (let i = 0; i < html.length; i++) {
        if (html[i] === '<') {
            inTag = true;
        }
        if (!inTag) {
            count++;
        }
        if (html[i] === '>') {
            inTag = false;
        }
        truncated += html[i];
        if (count >= limit && !inTag) {
            truncated += '...';
            break;
        }
    }
    return truncated;
};

const CourseUpdates = ({ text, link }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleText = () => {
        setIsExpanded(!isExpanded);
    };

    return (
        <>
            <hr className="mt-6 border-t border-dashed" />
            <div className="bg-cloudBlue p-6 mt-6 border border-brandMidBlue">
                <h2 className="section-title text-xl text-brandDarkBlue font-bold mb-4">Course updates</h2>
                <div
                    className="course__updates mb-4"
                    dangerouslySetInnerHTML={{ __html: isExpanded ? text : truncateHTML(text, 250) }}
                />
                <button
                    onClick={toggleText}
                    className="absolute bg-brandDarkBlue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-md"
                >
                    {isExpanded ? 'Read Less' : 'Read More'}
                </button>
            </div>
        </>
    );
};

export default CourseUpdates;